import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getTaxesRate } from 'actions/EntityActions';
import { taxListCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import LOOKUP from 'constants/lookup';
// Basic Components
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import Grid from 'screens/components/basic/Grid';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

class TaxRateList extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getTaxesRate(this.props.branchId);
    }

    redirectToAddTaxRate = () => {
        this.props.navigate("/manage/taxrate/add");
    }

    redirectToEditTaxRate = (id) => {
        this.props.navigate(`/manage/taxrate/edit/${id}`);
    }

    render() {
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.manage.items.taxrate.text}</li>
                </ol>
                <h2>{LOOKUP.menu.manage.items.taxrate.text}</h2>
            </div>);

        const sideContent = null;

        const listTaxesRate = (this.props.taxesrate || []).map((item) => {
            return {
                ID: (<Link className="edit-link" to={`/manage/taxrate/edit/${item.id}`}>{item.id}</Link>),
                Name: (<Link to={`/manage/taxrate/edit/${item.id}`}>{item.name}</Link>),
                Rate: `${(item.rate * 100).toFixed(0)}%`,
                Status: item.status,
                Icons: (
                    <div>
                        <Button
                            type="IconEditButton"
                            label={LOOKUP.taxrate.controls.editButton}
                            onTouchTap={() => this.redirectToEditTaxRate(item.id)} />
                    </div>
                )
            };
        });

        return (
            <Grid headerContent={taxListCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.manage.items.taxrate.text}>
                    <Button
                        type="AddButton"
                        mini={true}
                        className="bg-light-green"
                        label={LOOKUP.taxrate.controls.addNewButton}
                        onTouchTap={() => this.redirectToAddTaxRate()}
                    />
                </PageHeaderWithButton>
                <GenericTable
                    multiSelectable={false}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={false}
                    columns={LOOKUP.taxrate.tableColumns}
                    rows={listTaxesRate}
                    stripedRows={true}
                />
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        taxesrate: state.entity.taxesrateList,
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getTaxesRate: (branchId) => dispatch(getTaxesRate(branchId))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(TaxRateList));